<template>
    <div class="wrapper col">
        <div class="section">
            <h2>{{ $store.state.user.data.email }}</h2>
            <h2>{{ $store.state.user.data.displayName }}</h2>
            <SubmitButton
                @click="$router.push('/logout')"
                text="Log Out"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'User',
    props: ['userId']
}
</script>

<style lang="scss" scoped>
@import '../interface.scss';
</style>